import Loadable from 'react-loadable';

import { Settings } from '@atlaskit/navigation-system/top-nav-items';

import { publishUiEvent } from 'src/utils/analytics/publish';

import { useTopNavData } from './hooks';

const HorizontalSettingsBase = Loadable({
  loading: () => null,
  loader: () =>
    import(
      'src/components/navigation/src/components/horizontal-nav/horizontal-settings'
    ).then(module => ({
      default: module.HorizontalSettingsBase,
    })),
});

export const TopNavSettings = (): JSX.Element => {
  const {
    currentWorkspace,
    isOrgAdmin,
    workspaceOrgId,
    ccpEntitlementId,
    ccpTransactionAccountId,
    canViewEntitlement,
    adminHubUrl,
    menuItems,
  } = useTopNavData();

  return (
    <HorizontalSettingsBase
      currentWorkspace={currentWorkspace}
      isOrgAdmin={isOrgAdmin}
      workspaceOrgId={workspaceOrgId}
      ccpEntitlementId={ccpEntitlementId}
      ccpTransactionAccountId={ccpTransactionAccountId}
      canViewEntitlement={canViewEntitlement}
      adminHubUrl={adminHubUrl}
      menuItems={menuItems}
      publishUiEvent={publishUiEvent}
      triggerComponent={Settings}
    />
  );
};
